import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";
import Banner1 from "../../assets/images/banavt1.png";
import Banner2 from "../../assets/images/banavt2.png";
import Banner3 from "../../assets/images/banavt3.png";
import Banner4 from "../../assets/images/play.svg";
import Banner5 from "../../assets/images/googleplay.png";
import Banner6 from "../../assets/images/appstorebtn.png";
import Banner7 from "../../assets/images/smallStar.png";
import Banner8 from "../../assets/images/bigstar.png";
import Banner9 from "../../assets/images/bannerScreen.png";
import Screen1 from "../../assets/images/bannerScreen2.png";
import Screen2 from "../../assets/images/bannerScreen3.png";
import Icon from "../../assets/images/iphonescren.png";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Pagination } from 'swiper/modules';
import "swiper/css/pagination";
import "swiper/css/navigation";
import shuffleArray from '../../utils/shuffleArray';
import { Link as ScrollLink } from "react-scroll";

// Image from public folder (not in src/assets/images)
const DescoperaLumo = "/assets/images/descoperaLUMO.png";

const Slidernew = {
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 1,
    },
    1000: {
      items: 1,
    },
  },
};


function injectDelays(array, delay) {
  return array.flatMap((text) => [text, delay]);
}

function Banner({ typeAnimationDataPhrases, typeAnimationTypeSpeed, typeAnimationDeletionSpeed, typeAnimationPauseTime }) {
  const [ytban, setytban] = useState(false);
  const [sequence, setSequence] = useState([]);

  useEffect(() => {
    // AI Generated Texts Sequnce
    // generatePhrases().then(setSequence);

    setSequence(injectDelays(shuffleArray(typeAnimationDataPhrases), typeAnimationPauseTime));
    
  }, []);

  return (
    <>
      <section className="banner_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12" data-aos="fade-up" data-aos-duration={1500} >
              <div className="banner_text">
                <div className="type-wrap">
                  {sequence.length > 0 && (
                      <TypeAnimation
                        id="typed"
                        sequence={sequence}
                        speed={typeAnimationTypeSpeed}
                        deletionSpeed={typeAnimationDeletionSpeed}
                        repeat={Infinity}
                        style={{ whiteSpace: "pre" }}
                      />
                    )}
                </div>
                <h1>
                Platforma de <span>rezervări online</span> pentru servicii locale
                </h1>
                <p>
                Descoperă profesioniști de încredere din orașul tău, rezervă rapid online și transformă fiecare programare în puncte de loialitate și premii reale.
                </p>
              </div>
              {/*<div className="used_app">
                <ul>
                  <li>
                    <img src={Banner1} alt="image" />
                  </li>
                  <li>
                    <img src={Banner2} alt="image" />
                  </li>
                  <li>
                    <img src={Banner3} alt="image" />
                  </li>
                  <li>
                    <Link to="#"
                      className="popup-youtube play-button"
                      data-url="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1"
                      data-toggle="modal" data-target="#myModal" title="XJj2PbenIsU" onClick={() => setytban(true)} >
                      <img src={Banner4} alt="img" />
                    </Link>
                  </li>
                </ul>
                <h3>12M + Active users</h3>
                <p>
                  The best application to manage your <br /> customer worldwide
                </p>
              </div>  */}
              <ul className="app_btn">
                <li>
                  <Link to="#">
                    <img className="blue_img" src={Banner5} alt="image" />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <img className="blue_img" src={Banner6} alt="image" />
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="banner_slider">
                <div className="left_icon">
                  <img src={Banner7} alt="image" />
                </div>
                <div className="right_icon">
                  <img src={Banner8} alt="image" />
                </div>
                <Swiper id="frmae_slider" className="mySwiper"  slidesPerView={1} autoplay={true} pagination={true} modules={[Pagination]} {...Slidernew} >
                  <SwiperSlide className="item">
                    <div className="slider_img">
                      <img src={Banner9} alt="image" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="item">
                    <div className="slider_img">
                      <img src={Screen1} alt="image" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="item">
                    <div className="slider_img">
                      <img src={Screen2} alt="image" />
                    </div>
                  </SwiperSlide>
                </Swiper>
                <div className="slider_frame">
                  <img src={Icon} alt="image" />
                </div>
              </div>
            </div>
          </div>
          <div className="spinBlock" data-aos="fade-up" data-aos-duration={1500} >
            <span className="star">

            </span>
            <div className="spin_box" id="scrollButton">
              <ScrollLink
                to="about"
                smooth={true}
                duration={800}
                offset={-60} // Optional, if you want to offset for a sticky header
              >
                <span className="downsign">
                  <i className="icofont-long-arrow-down" />
                </span>
              </ScrollLink>
              <div className="spin-text">
                <img src={DescoperaLumo} alt="image" />
              </div>
            </div>
            <span className="star">

            </span>
          </div>
        </div>
      </section>

      {ytban && (
        <div className="modal fade youtube-video show" id="myModal" tabIndex={-1} style={{ display: "block", paddingRight: 17 }} aria-modal="true" role="dialog" >
          <div className="modal-dialog" role="document">
            <div className="modal-content" onClick={() => setytban(false)}>
              <button id="close-video"
                type="button"
                className="button btn btn-default text-right"
                data-dismiss="modal"
                onClick={() => setytban(false)} >
                <i className="icofont-close-line-circled" />
              </button>
              <div className="modal-body">
                <div id="video-container" className="video-container">
                  <iframe
                    id="youtubevideo"
                    width={640}
                    height={360}
                    allowFullScreen=""
                    src="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1"
                  />
                </div>
              </div>
              <div className="modal-footer"></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

Banner.defaultProps = {
  typeAnimationDataPhrases: [
    "Rezervă un serviciu din aplicație",
    "Adaugă afacerea ta pe LUMO",
    "Descoperă profesioniști locali"
  ]
};

export default Banner;